import GradientBackground from '../components/GradientBackground/GradientBackground';
import ReportIssueForm from '../components/ReportIssue/ReportIssueForm';

const ReportIssue = () => {
  return (
    <main className="overflow-hidden relative flex align-center justify-center flex-col">
      <div className="relative flex items-center h-[125px] px-[60px]">
        <GradientBackground />
        <h1 className="z-10 text-[40px] font-normal">Report Issue</h1>
      </div>

      <ReportIssueForm />
    </main>
  );
};
export default ReportIssue;
